// modules
import { createAction } from 'redux-actions'

export const setTelemedicineBillingCodes = createAction(
  'SET_TELEMEDICINE_BILLING_CODES'
)
